import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'mh-core-lib-followup-onsite-widget',
    templateUrl: './followup-onsite-widgets.component.html',
    styleUrls: ['./followup-onsite-widgets.component.scss'],
    standalone: false
})
export class CoreLibFollowupOnsiteWidgetsComponent implements OnInit {

  @Input()
  title = '';

  @Input()
  className = '';

  @Input()
  articleClassName = '';

  @Input()
  heightClass = 'tw-h-52';

  @Input()
  tooltip = '';

  constructor() { }

  ngOnInit(): void {
  }

}
